import {useContext} from "react";
import {ConfirmDialogContext} from "../contexts/ConfirmDialogContext";


export const useConfirmDialog = () => {
    return useContext(ConfirmDialogContext);
}